import React from "react";
import styles from "../styles.module.css";
import { getSentenceFromCamelCase } from "./Helpers";
import { TextareaProps } from "../../interface/form";

const Textarea = ({
  className,
  disabled,
  error,
  required,
  label,
  name,
  onChange,
  placeholder,
  style,
  validationHandler,
  value,
  size,
  labelClassName,
}: TextareaProps) => {
  const onChangeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = event.target;
    onChange && onChange(name, value);
  };

  const onValidationChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    if (!validationHandler) return;
    const { value } = event.target;
    let errorMessage = "";
    if (!value && required) {
      errorMessage = `Please enter ${getSentenceFromCamelCase(name)}.`;
    }
    validationHandler(name, errorMessage);
  };
  return (
    <div className={`${styles.InputContainer} ${styles[size ? size : ""]}`}>
      <label htmlFor={name} className={labelClassName}>
        {label} {required && <span className={styles.required}>&nbsp;*</span>}
      </label>

      {error ? (
        <span className={`${styles.required} ${styles.textSmall}`}>
          {error}
        </span>
      ) : null}
      <textarea
        id={name}
        name={name}
        value={value}
        placeholder={placeholder}
        required={required}
        readOnly={disabled}
        className={`${styles.blackBorder} ${className}`}
        style={style}
        onChange={onChangeHandler}
        onBlur={onValidationChange}
      ></textarea>
    </div>
  );
};

export default Textarea;
